import { render, staticRenderFns } from "./ListaPedidos.vue?vue&type=template&id=7af3e2e4&"
import script from "./ListaPedidos.vue?vue&type=script&lang=js&"
export * from "./ListaPedidos.vue?vue&type=script&lang=js&"
import style0 from "./ListaPedidos.vue?vue&type=style&index=0&id=7af3e2e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports